import { call, put, select } from 'redux-saga/effects';
import { getFileInfoById, getFileInfoState, getThumbnailFileInfo } from "../../file";
import { photoCaptureDataFailureAction, photoCaptureIntelligentAddEstimatedSummaryFileInfoAction, photoCaptureIntelligentUpdateCameraFileStatusAction, photoCaptureIntelligentUpdateIterationUploadFailedCountAction } from '../actions';
import { IntelligentPhotoCaptureAttachmentIterationStatus } from '../enums';
import { getAttachmentIterationInfo } from '../selectors';
import { isFileUploadStatusFailed } from '../utilities';
import { batchChain, getImageBatchConfig } from './intelligentPhotoCaptureImageBatchProcessingSaga';
import { intelligentPhotoCaptureCameraCompleteIterationSaga } from './intelligentPhotoCaptureUpdateIterationUploadingStatusSaga';
export function* intelligentPhotoCaptureTakePhotoUploadSuccessSaga(action) {
    try {
        const { fileId, imageName, iterationId } = action.payload;
        const fileInfo = yield select(getFileInfoById, fileId);
        if (!fileInfo)
            throw new Error(`File not found: ${fileId}`);
        if (isFileUploadStatusFailed(fileInfo)) {
            yield put(photoCaptureIntelligentUpdateIterationUploadFailedCountAction(iterationId, 1));
        }
        else {
            const file = yield select(getFileInfoById, fileInfo.id);
            yield put(photoCaptureIntelligentAddEstimatedSummaryFileInfoAction(fileInfo));
            const fileInfoState = yield select(getFileInfoState);
            const thumbnailFileInfo = getThumbnailFileInfo(fileInfoState, fileInfo.id);
            if (thumbnailFileInfo) {
                yield put(photoCaptureIntelligentAddEstimatedSummaryFileInfoAction(thumbnailFileInfo));
            }
            const imageBatchConfig = yield call(getImageBatchConfig);
            yield call([batchChain, batchChain.addItemToProcessor], file, imageBatchConfig);
        }
        yield put(photoCaptureIntelligentUpdateCameraFileStatusAction(iterationId, imageName, IntelligentPhotoCaptureAttachmentIterationStatus.COMPLETED));
        const iterationInfoList = yield select(getAttachmentIterationInfo);
        const iteration = iterationInfoList.find((iteration) => iteration.iterationId === iterationId);
        yield call(intelligentPhotoCaptureCameraCompleteIterationSaga, iteration);
    }
    catch (error) {
        yield put(photoCaptureDataFailureAction(error.toString()));
    }
}
//# sourceMappingURL=intelligentPhotoCaptureTakePhotoUploadSuccessSaga.js.map